<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙分销<img class="title_bg" style="width:64px;height:12px;" src="@/assets/Mobile/images/QcDistribution/title_bg.png" alt=""></div>
            <div class="banner_line"></div>
            <div class="banner_title2">打造以业务员为核心的超级业务员管理系统</div>
            <div class="banner_text">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div>
        </div>
        <img src="@/assets/Mobile/images/QcDistribution/banner.png" alt="">
      </div>
      <div class="block01">
        <div class="sk-mobile-title">
          <div class="title">基于企业微信，连接客户和业务员，打通企业业务系统，助力业务员高效分销交易</div>
        </div>
        <div class="content block1_content1">
            <img class="block02_img" src="@/assets/Mobile/images/QcDistribution/content1.png" alt="">
        </div>
      </div>

      <div class="step step1">
        <div class="sk-mobile-title">
          <div class="title">全渠道引流获客，沉淀客户资产</div>
        </div>
        <div class="content">
            <img class="content_bg" src="@/assets/Mobile/images/QcDistribution/content2.png" alt="">
            <div class="content_box">
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box1.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">智能活码</div>
                        <div class="right_text">打造员工专属获客活码，多渠道引流获客，扫码添加自动通过，永久有效，自动推送个性化欢迎语</div>
                    </div>
                </div>
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box2.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">客户标签</div>
                        <div class="right_text">根据用户行为、客户价值分级添加标签，实现客户分层管理，精细化运营，像了解你的朋友一样了解客户</div>
                    </div>
                </div>
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box3.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">在离职继承</div>
                        <div class="right_text">员工离职、换岗时，所有客户资料一键同步，避免因人员变动导致的服务断档甚至客户流失。</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="step">
        <div class="sk-mobile-title">
          <div class="title">连接企业微信，高效运营，精准触达</div>
        </div>
        <div class="content">
            <img class="content_bg" src="@/assets/Mobile/images/QcDistribution/content3.png" alt="">
            <div class="content_box">
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box4.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">轨迹素材</div>
                        <div class="right_text">支持多种类型素材的分享管理，24小时自动抓取客户访问动态轨迹，客户动态早知道。</div>
                    </div>
                </div>
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box5.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">群发工具</div>
                        <div class="right_text">多种群发方式,1分钟,我的所有客户收到了适合他们的活动和商品。</div>
                    </div>
                </div>
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box6.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">客户朋友圈</div>
                        <div class="right_text">企业统一创建客户朋友圈发表内容，让它成为产品推广和品牌宣传的阵地。</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="step step1">
        <div class="sk-mobile-title">
          <div class="title">销售行为透明管理，员工聚焦销售执行，提升服务效率</div>
        </div>
        <div class="content">
            <img class="content_bg" src="@/assets/Mobile/images/QcDistribution/content4.png" alt="">
            <div class="content_box">
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box7.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">外勤管理</div>
                        <div class="right_text">员工拜访基于LBS定位打卡，实时掌控业务员拜访轨迹，把控工作动向</div>
                    </div>
                </div>
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box8.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">任务管理</div>
                        <div class="right_text">搭建销售团队标准化管理平台，统一分配拜访任务。</div>
                    </div>
                </div>
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box9.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">数据管理</div>
                        <div class="right_text">获客数据、员工销售行为数据、商机转化数据实时统计，管理员和员工随时查看，把控整体销售进度，用数据助力企业把控员工销售质量</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="step">
        <div class="sk-mobile-title">
          <div class="title">从商品分享到客户商城下单全流程交易闭环</div>
        </div>
        <div class="content">
            <img class="content_bg" src="@/assets/Mobile/images/QcDistribution/content5.png" alt="">
            <div class="content_box">
                <div class="box_item" style="height:81px;">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box10.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">商城对接</div>
                        <div class="right_text">对接企业自主商城，打通客户数据，实现报价、交易全闭环。</div>
                        <div class="btn_box">
                            <div class="btn_left">另可选我司企业电商产品，与千橙分销系统原生打通，助力企业高效分销</div>
                            <div class="btn_right" @click="linkTo('QcB2BChannel')">千橙B2b</div>
                        </div>
                    </div>
                </div>
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box11.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">ERP对接</div>
                        <div class="right_text">对接主流ERP系统,完成订单快速录入,数据及时同步,服务进度透传。</div>
                    </div>
                </div>
                <div class="box_item">
                    <div class="item_left">
                        <img src="@/assets/Mobile/images/QcDistribution/box12.png" alt="">
                    </div>
                    <div class="item_right">
                        <div class="right_title">开放标准API</div>
                        <div class="right_text">开放API对接能力，赋能企业业务深度整合。</div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">开放服务能力，为企业高效、低成本打造专属业务数字化方案</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcDistribution/programme1.png" alt="">
            <img src="@/assets/Mobile/images/QcDistribution/programme2.png" alt="">
            <img src="@/assets/Mobile/images/QcDistribution/programme3.png" alt="">
        </div>
      </div>
      <div class="programme" style="background:rgba(234,243,255,.67)">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcDistribution/case1.png" alt="">
            <img src="@/assets/Mobile/images/QcDistribution/case2.png" alt="">
            <img style="margin-bottom: 18px;" src="@/assets/Mobile/images/QcDistribution/case3.png" alt="">
        </div>
      </div>
      <div class="programme" style="background:#f0f2f5">
        <div class="sk-mobile-title">
          <div class="title">专注分销领域，专业团队服务</div>
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcDistribution/service.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙分销" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙分销" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcDistribution,
    components: {
      ContactForm,
      IndustrySolution,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .title_bg{
    float: right;
    width: 64px;
    height: 12px;
    margin-top: 5px;
    margin-left: 5px;
  }
  .step1{
    background: url('~@/assets/Mobile/images/QcDistribution/content_bg1.png');
  }
  .btn_box{
    width: 262px;
    height: 42px;
    background: #F5FAFF;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding:7px;
    .btn_left{
        width: 165px;
        height: 29px;
        font-size: 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 15px;
        text-align: left;
    }
    .btn_right{
        width: 77px;
        height: 20px;
        background: #3986FF;
        border-radius: 2px;
        text-align: center;
        line-height:20px;
        font-size: 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
    }
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
        display: flex;
        align-items: center;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 9px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:8px;
        width: 134px;
        height: 78px;
        font-size: 7px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 13px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .block01 {
    background-color: #f0f2f5;
    padding:0 16px;
    .block1_content1{
        padding-top: 21px;
        padding-bottom:39px;
    }
    .content{
        width: 343px;
        img{
            width: 100%;
            height:100%;
        }
    }
  }
  .block02{
    background: #D8D8D8;
  }
 
  </style>
  